import styled, {css} from 'styled-components'

export const StyledAccessesGrid = styled.div(
    ({theme: {spacing}}) => css`
        display: grid;
        grid-template-columns: minmax(0, 1fr) auto;
        gap: ${spacing * 2}px;
    `
)
